import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';

import { LinkedLogo } from '../../components';

import css from './TopbarSimplified.module.css';

const LockIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    aria-hidden="true"
    className={css.lockIcon}
  >
    <rect x="1" y="6" width="11" height="8" rx="2" fill="#c9a99a" />
    <path
      d="M3.5 6V4.5a3 3 0 0 1 6 0V6"
      stroke="#c9a99a"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <circle cx="6.5" cy="10" r="1" fill="#fdf8f5" />
  </svg>
);

/**
 * A simplified topbar used on checkout, offer, and inquiry pages.
 * Intentionally minimal to keep the user focused on completing their action.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @returns {JSX.Element}
 */
const TopbarSimplified = props => {
  const [isMobile, setIsMobile] = useState(false);
  const [mounted, setMounted] = useState(false);
  const intl = useIntl();
  const config = useConfiguration();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    let mediaQueryList = null;
    let updateIsMobile = null;

    if (mounted) {
      mediaQueryList = window.matchMedia('(max-width: 767px)');
      setIsMobile(mediaQueryList.matches);

      updateIsMobile = e => setIsMobile(e.matches);
      mediaQueryList.addEventListener('change', updateIsMobile);
    }

    return () => {
      if (mediaQueryList && updateIsMobile) {
        mediaQueryList.removeEventListener('change', updateIsMobile);
      }
    };
  }, [mounted]);

  const { className, rootClassName } = props;
  const linkToExternalSite = config?.topbar?.logoLink;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <nav className={classes} aria-label="Checkout navigation">
      <div className={css.inner}>
        <div className={css.logoWrap}>
          <LinkedLogo
            layout={isMobile ? 'mobile' : 'desktop'}
            alt={intl.formatMessage({ id: 'TopbarSimplified.goToLandingPage' })}
            linkToExternalSite={linkToExternalSite}
          />
        </div>

        <div className={css.badge}>
          <LockIcon />
          <span className={css.badgeText}>Secure checkout</span>
        </div>
      </div>
    </nav>
  );
};

export default TopbarSimplified;
